import { Investor } from "./InvestorCard";

export const superInvestors: Investor[] = [
  {
    name: "Warren Buffett",
    cik: "0001067983",
    imageUrl: "/warrenBuffett.jpg",
    fund: "Berkshire Hathaway",
  },
  {
    name: "Leopold Aschenbrenner",
    cik: "0002045724",
    imageUrl: "/situationalAwareness.webp",
    fund: "Situational Awareness LP",
  },
  {
    name: "Bill Ackman",
    cik: "0001336528",
    imageUrl: "/billAckman.webp",
    fund: "Pershing Square Capital Management",
  },
  {
    name: "Dan Ives",
    cik: "0001142495",
    imageUrl: "/danIves.jpg",
    fund: "Wedbush Securities",
  },
  {
    name: "Terry Smith",
    cik: "0001569205",
    imageUrl: "/terrySmith.webp",
    fund: "Fundsmith",
  },
  {
    name: "Michael Burry",
    cik: "0001649339",
    imageUrl: "/michaelBurry.jpg",
    fund: "Scion Asset Management Llc",
  },
  {
    name: "Chuck Akre",
    cik: "0001112520",
    imageUrl: "/chuckAkre.webp",
    fund: "Akre Capital Management",
  },
  {
    name: "Ray Dalio",
    cik: "0001350694",
    imageUrl: "/rayDalio.webp",
    fund: "Bridgewater Associates",
  },
  {
    name: "George Soros",
    cik: "0001029160",
    imageUrl: "/georgeSoros.webp",
    fund: "Soros Fund Management",
  },
  {
    name: "Jim Simons",
    cik: "0001037389",
    imageUrl: "/jimSimons.avif",
    fund: "Renaissance Technologies",
  },
  {
    name: "Stanley Druckenmiller",
    cik: "0001536411",
    imageUrl: "/stanDruckenmiller.png",
    fund: "Duquesne Family Office",
  },
  {
    name: "Howard Marks",
    cik: "0000949509",
    imageUrl: "/howardMarks.jpg",
    fund: "Oaktree Capital Management",
  },
  {
    name: "Chris Hohn",
    cik: "0001647251",
    imageUrl: "/chrisHohn.webp",
    fund: "Tci Fund Management",
  },
  {
    name: "Carl Icahn",
    cik: "0000921669",
    imageUrl: "/carlIcahn.webp",
    fund: "Icahn Enterprises",
  },
  {
    name: "Dev Kantesaria",
    cik: "0001697868",
    imageUrl: "/devKantesaria.avif",
    fund: "Valley Forge Capital Management",
  },
  {
    name: "Pat Dorsey",
    cik: "0001671657",
    imageUrl: "/patDorsey.jpg",
    fund: "Dorsey Asset Management",
  },
  {
    name: "Stephen Mandel",
    cik: "0001061165",
    imageUrl: "/stephenMandel.avif",
    fund: "Lone Pine Capital",
  },
  {
    name: "David Tepper",
    cik: "0001656456",
    imageUrl: "/profile-photos/david-tepper.webp",
    fund: "Appaloosa LP",
  },
  {
    name: "Seth Klarman",
    cik: "0001061768",
    imageUrl: "/profile-photos/seth-klarman.jpg",
    fund: "Baupost Group",
  },
  {
    name: "Daniel Loeb",
    cik: "0001040273",
    imageUrl: "/profile-photos/daniel-loeb.jpg",
    fund: "Third Point",
  },
  {
    name: "Li Lu",
    cik: "0001709323",
    imageUrl: "/profile-photos/li-lu.jpg",
    fund: "Himalaya Capital Management",
  },
  {
    name: "Mohnish Pabrai",
    cik: "0001549575",
    imageUrl: "/profile-photos/mohnish-pabrai.jpeg",
    fund: "Dalal Street",
  },
  {
    name: "Prem Watsa",
    cik: "0000915191",
    imageUrl: "/profile-photos/prem-watsa.jpg",
    fund: "Fairfax Financial Holdings",
  },
  {
    name: "Bill Miller IV",
    cik: "0001135778",
    imageUrl: "/profile-photos/bill-miller-iv.png",
    fund: "Miller Value Partners",
  },
  {
    name: "Tom Gayner",
    cik: "0001096343",
    imageUrl: "/profile-photos/tom-gayner.jpg",
    fund: "Markel Group",
  },
  {
    name: "Joel Greenblatt",
    cik: "0001510387",
    imageUrl: "/profile-photos/joel-greenblatt.png",
    fund: "Gotham Asset Management",
  },
  {
    name: "Chase Coleman",
    cik: "0001167483",
    imageUrl: "/profile-photos/chase-coleman.png",
    fund: "Tiger Global Management",
  },
  {
    name: "Andreas Halvorsen",
    cik: "0001103804",
    imageUrl: "/profile-photos/andreas-halvorsen.png",
    fund: "Viking Global Investors",
  },
  {
    name: "Philippe Laffont",
    cik: "0001135730",
    imageUrl: "/profile-photos/philippe-laffont.png",
    fund: "Coatue Management",
  },
  {
    name: "Ken Griffin",
    cik: "0001423053",
    imageUrl: "/profile-photos/ken-griffin.jpg",
    fund: "Citadel Advisors",
  },
  {
    name: "Steve Cohen",
    cik: "0001603466",
    imageUrl: "/profile-photos/steve-cohen.jpg",
    fund: "Point72 Asset Management",
  },
  {
    name: "David Shaw",
    cik: "0001009207",
    imageUrl: "/profile-photos/david-shaw.jpg",
    fund: "D. E. Shaw & Co.",
  },
  {
    name: "Paul Tudor Jones",
    cik: "0000923093",
    imageUrl: "/profile-photos/paul-tudor-jones.jpg",
    fund: "Tudor Investment Corporation",
  },
  {
    name: "Daniel Sundheim",
    cik: "0001747057",
    imageUrl: "/profile-photos/daniel-sundheim.jpg",
    fund: "D1 Capital Partners",
  },
  {
    name: "Cathie Wood",
    cik: "0001697748",
    imageUrl: "/profile-photos/cathie-wood.png",
    fund: "ARK Investment Management",
  },
];

export const congressionalInvestors: Investor[] = [
  // Congressional portfolios will be added here in the future
];
